// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import VueLocalStorage from 'vue-ls'
import VueResource from 'vue-resource'
import Vue2Filters from 'vue2-filters'
import moment from 'vue-moment'
import VModal from 'vue-js-modal'
import store from './store/store'
import VueSocketio from 'vue-socket.io'
import VueEvents from 'vue-events'
import VueProgressBar from 'vue-progressbar'
import VueI18n from 'vue-i18n'
import VueAnimateNumber from 'vue-animate-number'
import App from './App'

const socketio = require('socket.io-client') // 'socket.io-client'

// global.jQuery = jQuery
// global.$ = jQuery

Vue.config.productionTip = false

let options = {
  namespace: 'cellsmart.biz.masterAgent__'
}

Vue.use(VueResource)
Vue.use(VueLocalStorage, options)
Vue.use(Vue2Filters)
Vue.use(moment)
Vue.use(VModal)
Vue.use(VueEvents)
Vue.use(require('vue-chartist'))
Vue.use(VueProgressBar, {
  color: '#FFF907',
  failedColor: 'red'
})
Vue.use(VueI18n)
Vue.use(VueAnimateNumber)

const messages = require('../../Lang/lang')

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages // set locale messages
})

// const serverAddress = "https://cellsmartapi.herokuapp.com/"
const serverAddress = process.env.serverURL

const SocketInstance = socketio(serverAddress, {reconnection: true})
Vue.use(VueSocketio, SocketInstance)

Vue.filter('amountValue', (value) => {
  return parseFloat(value / 100).toFixed(2)
})

Vue.filter('state', (value) => {
  return value.replace(/US-/g, '')
})

Vue.http.interceptors.push((request, next) => {
  // console.log('start ', request)
  let orgID = Vue.ls.get('organization')
  request.headers.map['x-clientid'] = ['GXWCksIDm6LlmZfN']
  request.headers.map['token'] = [Vue.ls.get('token')]
  if (orgID) {
    request.headers.map['organizationid'] = [orgID.id]
  }

  next(response => {
    // console.log('saqib ', response)
    if (response.status === 401) {
      router.push({path: '/login'})
      if (response.body.token) {
        Vue.ls.set('token', response.body.token)
      }
    }
  })
})

router.beforeEach((to, from, next) => {
  if (!to.meta.title) {
    to.meta.title = 'Master Agent'
  }
  document.title = 'Master Agent - ' + to.meta.title
  next()
})

Vue.http.options.root = serverAddress + '/masterAgent/'
// Vue.http.options.root = 'http://stagingcspwebservices.us-east-1.elasticbeanstalk.com/'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js